export enum MediaType {
  YOUTUBE_VIDEO,
  IMAGE,
  GIPHY,
  VIDEO_FROM_DEVICE,
  DOCUMENT,
}

export interface Media {
  type: MediaType
}

export interface VideoMedia extends Media {
  id: string
  thumbnail: string | null
}

export interface ImageMedia extends Media {
  source: string
}

export interface VideoFromDeviceMedia extends Media {
  source: string
  thumbnail?: string | null
  subtitlesUrl?: string | null
}

export interface DocumentMedia extends Media {
  source: string
  name: string
}

export enum AttachmentType {
  VIDEO,
  IMAGE,
  GIPHY,
  DOCUMENT,
}

export enum AttachmentUploadStatus {
  PENDING,
  SUCCESS,
  FAILED,
}

export const CompressJobStatus = {
  CANCELED: 'CANCELED',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR',
  PROGRESSING: 'PROGRESSING',
  SUBMITTED: 'SUBMITTED',
}

export interface AttachmentUploadModel {
  url: string
  fileName: string
  type: AttachmentType
}
